/**
 * Generated by orval from the Collective Payroll API contract. Do not edit manually.
 */

/**
 * * `company` - company
 * * `employee` - employee
 * * `contractor` - contractor
 */
export type OwnerKindEnum = (typeof OwnerKindEnum)[keyof typeof OwnerKindEnum];

export const OwnerKindEnum = {
    company: 'company',
    employee: 'employee',
    contractor: 'contractor',
} as const;
